import KeyValuePair from '@/modules/core/support/KeyValuePair'
import _ from 'lodash'

/**
 * Describe la información de un paso asociado a una determinada guía
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class Step {
    public id = 0
    public title = ''
    public order = 0
    public content = ''
    public element = ''
    public position = 'bottom'
    public screen = ''

    /**
     * Identificador único temporal, utilizado en tiempo de ejecución cuando
     * el paso aún no posee un ID en el servidor
     */
    public readonly tempId = _.uniqueId('step_')

    public static deserialize (data: KeyValuePair) {
        const step = new this()
        step.id = data.id
        step.title = data.title
        step.order = data.order
        step.content = data.content
        step.position = data.position
        step.screen = data.screen || ''
        step.element = data.element || ''

        return step
    }

    /**
     * Serializa la entidad para enviarla en JSON
     */
    public serialize () {
        return {
            id: this.id || undefined,
            title: this.title,
            order: this.order,
            content: this.content,
            position: this.position,
            screen: this.screen,
            element: this.element,
        }
    }
}
